import { Injectable, TemplateRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface AlertConfig {
  content: string | TemplateRef<any>;
  title?: string | TemplateRef<any>;
  btnText?: string;
}

@Injectable()
export class AlertController {
  alertConfig: Observable<string | AlertConfig>;
  private alertAction: Observable<void>;
  private alertActionSource = new Subject<void>();
  private alertConfigSource = new Subject<string | AlertConfig>();

  constructor() {
    this.alertAction = this.alertActionSource.asObservable();
    this.alertConfig = this.alertConfigSource.asObservable();
  }

  show(params: string | AlertConfig): Promise<any> {
    // å½æ¥æ¶å°ç¨æ·äºä»¶æ¶ï¼åå¸ç¸åºäºä»¶ï¼å¹¶è¿å promiseï¼å½ç¨æ·ç¹å»ç¡®å®æ¶ï¼resolve å½å promise;

    this.alertConfigSource.next(typeof params === 'string' ? {
      content: params
    } : params);
    return new Promise((resolve) => {
      const sub = this.alertAction.subscribe(() => {
        resolve();
        sub.unsubscribe();
      });
    });
  }

  publishAction() {
    // åå¸ç¨æ·ç¹å»å¼¹åºæ¡çç¡®è®¤ææ­äºä»¶
    this.alertActionSource.next();
  }
}